export const MeminsuranceConstant = {
    FEED_REQUEST: 'FEED_MEMINSURANCE_REQUEST',
    FEED_SUCCESS: 'FEED_MEMINSURANCE_SUCCESS',
    FEED_FAILURE: 'FEED_MEMINSURANCE_FAILURE',
}
